import React, { useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { facilities } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import AddFacilitiesForm from '../../containers/AddFacilitiesForm';
import { useDispatch, useSelector } from 'react-redux';
import FacilityDetailPage from '../../containers/FacilityDetailPage';
import { setFacilitiesDetails, setSelectedFacility } from '../../redux/reducers/dataCaptures';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteFacility } from '../../api/dataCapture';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const FacilitiesTable = (props?: any) => {
    const { addData, handleClick } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const data = useSelector((state:any) => state.dataCaptures.facilitiesDetails);
  const dispatch = useDispatch();
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
        key: '', displayName: 'short name',
    },
    {
        key: '', displayName: 'total no. of grounds',
    },
    {
        key: '', displayName: 'facility status',
    },
    {
        key: '', displayName: '',
    }
  ];

  const manageDeleteRow = (row:any) => {
    deleteFacility({ clubId: clubDetails?.id, id: row?.id })
    .then(() => {
      const tempData = data?.filter((item:any) => item?.id != row?.id);
      dispatch(setFacilitiesDetails(tempData));
    });
  }
 

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative', mt: addData ? 7 : 0 }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        className='hoverBG'
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-row-${i}`}
                        onClick={() => {dispatch(setSelectedFacility(d));}}
                        >
                            <TableCell className='fs12'>
                                {d.shortName}
                            </TableCell>
                            <TableCell className='fs12'>
                                {d.facilityGrounds.length}
                            </TableCell>
                            <TableCell className='fs12 capitalize'>
                                {
                                  d.facilityStatus.split('_')[1]
                                }
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={(e:any) => {e.stopPropagation(); !isAdmin && manageDeleteRow(d);}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default FacilitiesTable;